// Do not import directly. Use with getRouter() and setRouter() only.
export const routerManager = {
  router: undefined
};